
import { authInterceptorProviders } from './../_helpers/auth.interceptor';
import { SharedModule } from './../shared/shared.module';
import { RegisterComponent } from './register/register.component';
import { AccountComponent } from './account/account.component';
import { SignInComponent } from './signin/signin.component';


import { RouterModule } from '@angular/router';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { UserShowComponent } from './user-show/user-show.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewUserComponent } from './new-user/new-user.component';
import { ActivateUserInfoComponent } from './activate-user-info/activate-user-info.component';
import { ConfirmRegistrationComponent } from './confirm-registration/confirm-registration.component';
import { ForgottenPasswordInputComponent } from './forgotten-password-input/forgotten-password-input.component';
import { ForgottenPasswordSendNewPassComponent } from './forgotten-password-send-new-pass/forgotten-password-send-new-pass.component';
import { RegisterStepOneEmailComponent } from './new-user/register-step-one-email/register-step-one-email.component';
import { RegisterStepTwoPasswordComponent } from './new-user/register-step-two-password/register-step-two-password.component';
import { RegisterStepThreeVerifyComponent } from './new-user/register-step-three-verify/register-step-three-verify.component';
import { RegisterStepFourGoComponent } from './new-user/register-step-four-go/register-step-four-go.component';
import { RegisterStepThreeVerifyByLinkComponent } from './new-user/register-step-three-verify-by-link/register-step-three-verify-by-link.component';
import { UserEditGeneralComponent } from './user-edit-general/user-edit-general.component';
import { UserEditAccessComponent } from './user-edit-access/user-edit-access.component';
import { ProtectionOfDataComponent } from './protection-of-data/protection-of-data.component';
import { ProtectionOfDataModalComponent } from './protection-of-data-modal/protection-of-data-modal.component';
import { ProtectionOfDataVerifyComponent } from './protection-of-data-verify/protection-of-data-verify.component';



@NgModule({
  declarations: [
    UserEditComponent,
    UserShowComponent,
    SignInComponent,
    AccountComponent,
    RegisterComponent,
    NewUserComponent,
    ActivateUserInfoComponent,
    ConfirmRegistrationComponent,
    ForgottenPasswordInputComponent,
    ForgottenPasswordSendNewPassComponent,
    RegisterStepOneEmailComponent,
    RegisterStepTwoPasswordComponent,
    RegisterStepThreeVerifyComponent,
    RegisterStepFourGoComponent,
    RegisterStepThreeVerifyByLinkComponent,
    UserEditGeneralComponent,
    UserEditAccessComponent,
    ProtectionOfDataComponent,
    ProtectionOfDataModalComponent,
    ProtectionOfDataVerifyComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule
  ],
  exports:[
    UserEditComponent,
    UserShowComponent,
    SignInComponent,
    AccountComponent,
    RegisterComponent,
    RegisterStepOneEmailComponent,
    SharedModule
  ],
  providers:[
    authInterceptorProviders
  ]
})
export class UserModule { }
